var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-btn",class:{ active: _vm.check },on:{"click":function($event){$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}},[(_vm.icon)?_c('div',{staticClass:"icon"},[_c('i',{staticClass:"iconfont",class:[_vm.icon]})]):_vm._e(),_c('div',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }